// extracted by mini-css-extract-plugin
export var brand = "_9g-9";
export var compact = "_9g-6";
export var extraSmall = "_9g-7";
export var icon = "_9g-0";
export var large = "_9g-4";
export var light = "_9g-1";
export var medium = "_9g-5";
export var outline = "_9g-b";
export var primaryDark = "_9g-a";
export var primaryLight = "_9g-8";
export var primaryModern = "_9g-c";
export var success = "_9g-2";
export var successSolid = "_9g-3";